// TODO: fix this !!!
/* eslint-disable @typescript-eslint/no-unsafe-assignment */

import type { Customer, DealBuyerData, DealSellerData } from '@dobrozem/sdk';
import clsx from 'clsx';
import Image from 'next/image';

import warningIcon from '@/assets/icons/warning-icon.svg';
import { Text } from '@/components/Text';

import { DocumentsUploaderForm } from '../DocumentsUploaderForm';
import { NecessaryDocuments } from '../NecessaryDocuments';
import styles from './BuyersDeal.module.scss';

type Props = {
  advertisementAuthor: Customer;
  advertisementId: string;
  className?: string;
  dealData?: DealBuyerData | DealSellerData;
  dealUserType: 'buyer' | 'seller' | null;
};

export const BuyersDeal = ({
  advertisementAuthor,
  advertisementId,
  className,
  dealData,
  dealUserType,
}: Props) => {
  return (
    <section className={clsx(styles.wrapper, className)}>
      <div className={styles.titleWrapper}>
        <Image alt='warningIcon' src={warningIcon} />
        <Text tag='h2' type='h4'>
          Завантажте документи
        </Text>
      </div>
      <DocumentsUploaderForm
        advertisementAuthor={advertisementAuthor}
        advertisementId={advertisementId}
        dealData={dealData}
        dealUserType={dealUserType}
      />
      <NecessaryDocuments />
    </section>
  );
};
